import { sanitiseNextPath } from "@/lib/leadDetailRules";

/** Item 111 — post-sign-in destination kept across the code step and the Google redirect. */
export const ADMIN_NEXT_KEY = "tango_admin_next";
export const ADMIN_NEXT_MAX_AGE_MS = 15 * 60 * 1000;

type Store = Pick<Storage, "getItem" | "setItem" | "removeItem">;

export function saveAdminNext(store: Store, raw: string | null | undefined, now = Date.now()): string {
  const path = sanitiseNextPath(raw);
  if (!path) return "";
  try { store.setItem(ADMIN_NEXT_KEY, JSON.stringify({ path, savedAt: now })); } catch { /* ignore */ }
  return path;
}

/** Reads without clearing. Stale or invalid values are cleared and return "". */
export function peekAdminNext(store: Store, now = Date.now()): string {
  let raw: string | null = null;
  try { raw = store.getItem(ADMIN_NEXT_KEY); } catch { return ""; }
  if (raw === null) return "";
  try {
    const v = JSON.parse(raw);
    const path = sanitiseNextPath(v?.path);
    const age = now - Number(v?.savedAt);
    if (path && Number.isFinite(age) && age >= 0 && age <= ADMIN_NEXT_MAX_AGE_MS) return path;
  } catch { /* fall through */ }
  try { store.removeItem(ADMIN_NEXT_KEY); } catch { /* ignore */ }
  return "";
}

/** One-shot: returns the saved path (if fresh and valid) and always clears it. */
export function takeAdminNext(store: Store, now = Date.now()): string {
  const path = peekAdminNext(store, now);
  try { store.removeItem(ADMIN_NEXT_KEY); } catch { /* ignore */ }
  return path;
}
